import React from 'react'
import styled from 'styled-components/macro'
import { rem } from '../../../../utils/styles'
import H1 from '../../../../components/H1'
import InfoBox from '../../../../components/InfoBox'
import SectorTable from './SectorTable'

const Title = styled(H1)`
  margin-bottom: ${rem(40)};
`

function Finished({ match }) {
  return (
    <InfoBox>
      <Title size='small' align='center'>Muchas gracias</Title>
      <p>La información que nos has aportado nos ayuda a conocer mejor tu proyecto. En los próximos días nos pondremos en contacto contigo para acompañarte en los siguientes pasos de la solicitud de financiación que acabas de iniciar.</p>
      <p>A continuación te presentamos los datos estadísticos de tu sector y la comparación con la economía nacional por si te puede ser útil.</p>
      <SectorTable match={match} />
    </InfoBox>
  )
}

export default Finished
